import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

/**
 * Format an ISO date string to DD/MM/YYYY (Argentine format).
 */
export function formatDate(iso: string | Date | null | undefined): string {
  if (!iso) return '';
  const date = typeof iso === 'string' ? parseISO(iso) : iso;
  return format(date, 'dd/MM/yyyy', { locale: es });
}

/**
 * Format an ISO date string to DD/MM/YYYY HH:mm.
 */
export function formatDateTime(iso: string | Date | null | undefined): string {
  if (!iso) return '';
  const date = typeof iso === 'string' ? parseISO(iso) : iso;
  return format(date, 'dd/MM/yyyy HH:mm', { locale: es });
}

/**
 * Format an integer with Argentine thousands separator (point).
 */
export function formatInteger(n: number | null | undefined): string {
  if (n === null || n === undefined) return '-';
  return new Intl.NumberFormat('es-AR').format(n);
}

/**
 * Capitalize first letter.
 */
export function capitalize(s: string): string {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Alias of formatDate — dd/mm/yyyy Argentine format. */
export function formatDateAR(value: Date | string | null | undefined): string {
  return formatDate(value);
}
